import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DownloadService } from '../../download/download.service';
import { StoreService } from '../../core/store.service';
import { HttpService, EndWithSlash } from 'projects/lib-components/src/public_api';
import { BaseStage } from '../base-stage';
import { SessionItem, eItem, StagesModel, Stage, StagePrice, WSRegMode, PathMode, PathName } from '../../shared';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'webstore-stage-detail',
  templateUrl: './stage-detail.component.html',
  styleUrls: ['./stage-detail.component.css']
})

export class StageDetailComponent extends BaseStage implements OnInit {

  stage: Stage;
  hasResponsable: boolean = false;

  startDate: string = '';
  endDate: string = '';
  totHours: string = '';
  place: string = '';
  listPrices: StagePrice[];
  fileName: string = '';

  objectif: string = '';
  pedagogie: string = '';
  programme: string = '';
  preRequis: string = '';

  redirectPage: string;
  hascursus: boolean;

  totIns: number = 0;
  totPre: number = 0;
  showComplet: boolean = false;
  showInscButton: boolean = true;

  constructor(
    public store: StoreService,
    private http: HttpService,
    private download: DownloadService,
    private router: Router
  ) { super(store); }

  ngOnInit(): void {
    this.initData();
  }

  selectStage(mode: string): void {
    super.setStage(this.stage);
    if (mode === 'INSC')
      this.router.navigate([this.redirectPage]);
    else
      this.router.navigateByUrl(this.store.AppRoutes.CYCLESLIST);
  }

  downloadDoc(): void {
    this.download.downloadFile(this.fileName);
  }

  private initData(): void {
    this.store.showSplash(true);

    this.redirectPage = this.store.begin.access === 'MIXED' ? '/inscriptions/formulaire' : '/inscriptions/extranet';
    this.store.AppSettings.RegistrationMode = WSRegMode.PREINSCRIPTION

    const s: SessionItem | null = super.getSession(eItem.STAGE);
    if (s && s.jsData && s.jsData !== '') {
      this.stage = JSON.parse(s.jsData);
      if (this.stage !== undefined) {
        this.hasResponsable = this.store.PathItem.hasResponsable(PathMode.SESSION, this.stage.Ident);

        this.startDate = this.stage.DatedPro;
        this.endDate = this.stage.DatefPro;
        this.totHours = this.stage.DureePRO;
        this.fileName = this.stage.PjextPRO && this.stage.PjextPRO !== '' ? this.stage.PjextPRO : '';

        this.listPrices = this.stage.PricesList.filter((p: StagePrice): boolean => p.Selected);

        this.objectif = this.stage.PartiPRO ? this.stage.PartiPRO : '';
      }

      const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/stageslist/getData/V2/INITDATASTAGE/${this.stage.Ident}`;
      this.http.getHttp<StagesModel>(destUrl).subscribe((dataStage: StagesModel): void => {
        if (!dataStage.HasError) {
          // --- check if the eventual stage's parent-product is different from the one returned by the new server request ---
          if (this.stage.ParentProduct && this.stage.ParentProduct.Ident !== '') {
            if (this.stage.ParentProduct.Ident !== dataStage.SelectedStageProduct.Ident) {
              this.store.showAlert('strange');
            }
          }
          // -----------------------------------------------------------------------------------------------------------------

          this.stage.ParentProduct = dataStage.SelectedStageProduct;
          if (this.stage.ParentProduct != null) {
            this.pedagogie = this.stage.ParentProduct.PedagPRO ? this.stage.ParentProduct.PedagPRO : '';
            this.programme = this.stage.ParentProduct.ProgrPRO ? this.stage.ParentProduct.ProgrPRO : '';
            this.preRequis = this.stage.ParentProduct.PreRePRO ? this.stage.ParentProduct.PreRePRO : '';
          }

          this.stage.ResponsablesList = dataStage.SelectedStageResponsablesList;

          this.stage.AddressesList = dataStage.SelectedStageaddressesList;
          if (this.stage.AddressesList && this.stage.AddressesList.length > 0) {
            this.place = this.stage.AddressesList[0].FormatADR;
          }

          this.totIns = dataStage.TotStageInscription;
          this.totPre = dataStage.TotStagePreinscription;
          this.showComplet = (!this.stage.CapstPRO || this.stage.CapstPRO === '')
            ? false
            : (this.totIns >= parseInt(this.stage.CapstPRO));
            //: !(parseInt(this.stage.CapstPRO) >= (this.totIns + this.totPre))

          this.showInscButton = !(dataStage.FullStage === 'block' && this.showComplet);

          this.store.showSplash(false);

          // TRACE ERROR (do not remove this line)
          if (!this.stage.ParentProduct) this.store.traceData(`--STAGE IDENT ${this.stage.Ident} ${this.stage.Info_PRO} HAS NOT A LINKED PRODUCT`);
          // TRACE ERROR (do not remove this line)
          if (!this.stage.ResponsablesList || this.stage.ResponsablesList.length === 0) this.store.traceData(`--STAGE IDENT ${this.stage.Ident} ${this.stage.Info_PRO} HAS NOT A LINKED RESPONSABLE`);
          // TRACE ERROR (do not remove this line)
          if (!this.stage.AddressesList || this.stage.AddressesList.length === 0) this.store.traceData(`--STAGE IDENT ${this.stage.Ident} ${this.stage.Info_PRO} HAS NOT A LINKED ADDRESS`);
        }
      }, (error: any): void => { JSON.stringify(error); });
    }
  }

}
